module.exports = __webpack_public_path__ + "static/media/hqx_completos_3er.425b362c.jpg";